import React, { useState } from 'react'
import styles from './QuickCatalog.module.css'

const isBranch = (value) => typeof value === 'object' && value !== null

const QuickCatalog = ({ groups, onSelect }) => {
  // Stack of keys describing where we are in the tree ([] === root)
  const [path, setPath] = useState([])

  // Resolve the node located at the given path
  const getNode = (p) => p.reduce((node, key) => node[key], groups)
  const current = getNode(path)

  const buildPath = (keys) => keys.join('-')

  // Either drill into a branch or fire the search for a leaf value
  const handleNode = (keys, value) => {
    if (isBranch(value)) {
      setPath(keys)
    } else {
      onSelect(value, buildPath(keys))
    }
  }

  const goTo = (index) => setPath(path.slice(0, index + 1))

  const PREVIEW_LIMIT = 6

  const entries = Object.entries(current)
  const branches = entries.filter(([, value]) => isBranch(value))
  const leaves = entries.filter(([, value]) => !isBranch(value))

  return (
    <div className={styles.catalog}>
      <div className={styles.header}>
        <span className={styles.title}>Каталог товарів</span>
        <span className={styles.subtitle}>
          Оберіть категорію для швидкого пошуку
        </span>
      </div>

      <div className={styles.breadcrumbs}>
        <span
          className={`${styles.crumb} ${
            path.length === 0 ? styles.crumbActive : ''
          }`}
          onClick={() => goTo(-1)}
        >
          Всі групи
        </span>
        {path.map((key, i) => (
          <React.Fragment key={i}>
            <span className={styles.crumbSep}>›</span>
            <span
              className={`${styles.crumb} ${
                i === path.length - 1 ? styles.crumbActive : ''
              }`}
              onClick={() => goTo(i)}
            >
              {key}
            </span>
          </React.Fragment>
        ))}
      </div>

      {leaves.length > 0 && (
        <div className={styles.chips}>
          {leaves.map(([key, value]) => (
            <button
              key={key}
              className={styles.chip}
              onClick={() => handleNode([...path, key], value)}
            >
              {key}
            </button>
          ))}
        </div>
      )}

      {branches.length > 0 && (
        <div className={styles.grid}>
          {branches.map(([key, value]) => {
            const childEntries = Object.entries(value)
            const preview = childEntries.slice(0, PREVIEW_LIMIT)
            const rest = childEntries.length - preview.length

            return (
              <div key={key} className={styles.card}>
                <button
                  className={styles.cardHeader}
                  onClick={() => handleNode([...path, key], value)}
                >
                  <span className={styles.cardTitle}>{key}</span>
                  <span className={styles.cardArrow}>›</span>
                </button>
                <div className={styles.cardBody}>
                  {preview.map(([childKey, childValue]) => (
                    <button
                      key={childKey}
                      className={styles.subItem}
                      onClick={() =>
                        handleNode([...path, key, childKey], childValue)
                      }
                    >
                      <span className={styles.subItemText}>{childKey}</span>
                      {isBranch(childValue) && (
                        <span className={styles.subItemArrow}>›</span>
                      )}
                    </button>
                  ))}
                  {rest > 0 && (
                    <button
                      className={styles.moreItem}
                      onClick={() => handleNode([...path, key], value)}
                    >
                      Ще {rest}…
                    </button>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default QuickCatalog
